import React from 'react';
import PropTypes from 'prop-types';
import { errors } from '../../constants';
import { filesize } from 'filesize';
import Entity from '../Entity';

const ChooseFile = ({ title, file, accept, accepList, isInactive, setFile, setError, testId }) => {
  const hiddenFileInput = React.useRef(null);

  const fileChangedHandler = e => {
    const file = e && e.target && e.target.files[0] && e.target.files[0];
    const fileType = file && file.type;

    if (!accepList.includes(fileType)) {
      setError(errors.FILE_NOT_SUPPORTED);
      e.target.value = null;
      return;
    }

    if (file && file.size > 52428800) {
      setError(errors.FILE_SIZE);
      e.target.value = null;
      return;
    }

    setFile(e.target.files[0]);
    e.target.value = null;
  };

  const handleAddClick = () => {
    setError(null);
    hiddenFileInput.current.click();
  };

  const handleRemoveClick = () => setFile(false);

  return <>
    {!file && <>
      <input
        type='file'
        onChange={fileChangedHandler}
        ref={hiddenFileInput}
        accept={accept && accept}
        style={{ display: 'none' }} />
      <Entity
        title={title || 'Upload Document'}
        testId={testId}
        isAdd
        isInactive={isInactive}
        onClick={handleAddClick} />
    </>}
    {file &&
      <Entity
        title={file && file.name}
        testId={testId}
        subTitle={file.size && filesize(file.size, { base: 10 })}
        handleRemove={handleRemoveClick} />
    }
  </>;
};

ChooseFile.propTypes = {
  title: PropTypes.string,
  testId: PropTypes.string,
  isInactive: PropTypes.bool,
  file: PropTypes.object,
  accept: PropTypes.string,
  accepList: PropTypes.array,
  setError: PropTypes.func
};

export default ChooseFile;
